export const ODOO_MODULE_ITEMS = [
  { value: "crm", label: "CRM", grp: "Odoo" },
  { value: "sales", label: "Sales (Odoo)", grp: "Odoo" },
  { value: "pos", label: "POS", grp: "Odoo" },
  { value: "procurement", label: "Procurement", grp: "Odoo" },
  { value: "production", label: "Production", grp: "Odoo" },
  { value: "inventory", label: "Inventory", grp: "Odoo" },
  { value: "task", label: "Task", grp: "Odoo" },
  { value: "employee", label: "Employee", grp: "Odoo" },
  { value: "disciplinary", label: "Disciplinary", grp: "Odoo" },
  { value: "accounting", label: "Accounting", grp: "Odoo" },
];

export const TALLY_MODULE_ITEMS = [
  { value: "sales_ch", label: "Sales", grp: "Tally", path: "sales-ch" },
  { value: "purchases_exp_tally", label: "Purchases & Expenses", grp: "Tally", path: "purchases-exp" },
  { value: "pl_ch", label: "P&L", grp: "Tally", path: "pl" },
  { value: "geo_ch", label: "Geo Revenue", grp: "Tally", path: "geo" },
  { value: "inventory_ch", label: "Inventory", grp: "Tally", path: "inventory-ch" },
  { value: "cashflow_direct", label: "Cash Flow", grp: "Tally", path: "cashflow" },
  { value: "balance_ch", label: "Balance Sheet", grp: "Tally", path: "balance-ch" },
  { value: "arap_ch", label: "AR / AP", grp: "Tally", path: "arap-ch" },
  { value: "accuracy_ch", label: "Accuracy", grp: "Tally", path: "accuracy" },
  { value: "gstr2b_reco", label: "2B Reco", grp: "Tally", path: "gstr2b-reco" },
];

export const moduleItems = [...ODOO_MODULE_ITEMS, ...TALLY_MODULE_ITEMS];
export const ODOO_MODULE_KEYS = ODOO_MODULE_ITEMS.map((item) => item.value);
export const TALLY_MODULE_KEYS = TALLY_MODULE_ITEMS.map((item) => item.value);
export const ANALYTICS_DASHBOARD_KEYS = new Set(TALLY_MODULE_KEYS);
export const TALLY_HOME_ORDER = TALLY_MODULE_ITEMS.map((item) => ({
  key: item.value,
  path: item.path,
}));
